export const UsersEnum = {
  DRIVER: "driver",
  CLIENT: "client",
  EMPLOYEE: "employee",
};
